
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.992 4.336A5.67 5.67 0 005.328 10a5.67 5.67 0 005.664 5.664A5.67 5.67 0 0016.656 10a5.67 5.67 0 00-5.664-5.664zm-.384 6.291a1.836 1.836 0 01-3.672 0V9.373a1.836 1.836 0 013.672 0v1.254zm2.917 1.835h-1.812V11.29h1.812a.352.352 0 000-.703h-.624a1.526 1.526 0 01-1.078-2.603c.288-.287.67-.446 1.078-.446l1.81.002v1.172l-1.81-.002a.35.35 0 00-.352.353c0 .194.157.352.352.352h.624c.84 0 1.524.683 1.524 1.523 0 .84-.684 1.524-1.524 1.524z","fill":"#E2E8F0"}}),_c('path',{attrs:{"d":"M8.773 8.709a.664.664 0 00-.664.664v1.254a.664.664 0 001.329 0V9.373a.664.664 0 00-.665-.664z","fill":"#E2E8F0"}}),_c('path',{attrs:{"d":"M19.54 8.125a8.7 8.7 0 00-1.178-2.843l1.027-1.027-2.652-2.652-1.026 1.027a8.7 8.7 0 00-2.844-1.178V0h-3.75v1.452A8.7 8.7 0 006.274 2.63L5.247 1.603 2.595 4.255l1.027 1.027a8.7 8.7 0 00-1.178 2.843H.992v3.75h1.452a8.7 8.7 0 001.178 2.844l-1.027 1.026 2.652 2.652 1.027-1.027a8.7 8.7 0 002.843 1.178V20h3.75v-1.452a8.7 8.7 0 002.844-1.178l1.026 1.027 2.652-2.652-1.027-1.026a8.7 8.7 0 001.178-2.844h1.452v-3.75H19.54zm-8.548 8.71A6.844 6.844 0 014.156 10a6.844 6.844 0 016.836-6.836A6.844 6.844 0 0117.828 10a6.844 6.844 0 01-6.836 6.836z","fill":"#E2E8F0"}})])
          )
        }
      }
    